"use client";

import { StoreScreen } from "@/features/store/StoreScreen";

export default function StorePage() {
  return <StoreScreen />;
}
